import { render } from "./ReversedBar.vue?vue&type=template&id=06b264fd"
import script from "./ReversedBar.vue?vue&type=script&lang=js"
export * from "./ReversedBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__